import { FleekError } from './FleekError';

type VerificationSessionAlreadyExistsErrorOptions = Record<string, never>;

export class VerificationSessionAlreadyExistsError extends FleekError<VerificationSessionAlreadyExistsErrorOptions> {
  public name = 'VerificationSessionAlreadyExistsError';

  constructor() {
    super({});
  }

  toString = () => `Verification session already exists.`;
}
